import React from 'react';
import { useTranslation } from 'react-i18next';

import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { faFilter } from '@fortawesome/pro-solid-svg-icons';

import Button from 'components/atom/Form/Button';
import Input from 'components/atom/Form/Input';
import { Wrapper } from 'components/atom/Grid';

import { useSearchController } from '../../hooks/useSearchController';
import { Container } from './styles';

interface IToolbarSearchProps {
  isApp?: boolean;
}

const ToolbarSearch: React.FC<IToolbarSearchProps> = ({ isApp = false }) => {
  const { setIsOpenModalFilters, searchText, setSearchText } = useSearchController();
  const { t } = useTranslation();

  return (
    <Container isApp={isApp}>
      <Wrapper>
        <Input
          icon={faSearch}
          id="search"
          name="search"
          placeholder={t('meetings:search.placeholder')}
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />

        <Button
          theme="blue03-bordered"
          icon={faFilter}
          onClick={() => setIsOpenModalFilters(true)}
        />
      </Wrapper>
    </Container>
  );
};

export default ToolbarSearch;
